module.exports = __webpack_public_path__ + "img/lageplan_800.ae68a4cd.webp";